module.exports = __webpack_public_path__ + "img/meta.402698b0.jpg";